import { render, staticRenderFns } from "./shopSearchInput.vue?vue&type=template&id=27484cae&scoped=true"
import script from "./shopSearchInput.vue?vue&type=script&lang=js"
export * from "./shopSearchInput.vue?vue&type=script&lang=js"
import style0 from "./shopSearchInput.vue?vue&type=style&index=0&id=27484cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27484cae",
  null
  
)

export default component.exports